import groupBy from 'lodash/groupBy';
import Box from '@mui/material/Box';

import CustomBox from '../common/CustomBox';
import CustomSubheader from './CustomSubheader';
import ProviderCustomList from './ProviderCustomList';
import './ProviderHowITreat.scss';

const ProviderHowITreat = props => {
  const { provider } = props;
  const categories = groupBy(provider.howITreat, i => i.subcategory);
  if (!provider.howITreat || !provider.howITreat.length) return <></>;
  const listItems = provider.howITreat.map(issue => issue.title);
  return (
    <CustomBox borderless className='ProviderHowITreat'>
      <Box marginBottom={{ xs: '10px', sm: '12px' }}>
        <CustomSubheader>
          How I Treat
        </CustomSubheader>
      </Box>      
      <ProviderCustomList
        items={listItems}
        borderBottomList
      />
    </CustomBox>
  );
};

export default ProviderHowITreat;
